import moment from 'moment';
import {dateMMddYYYYFormat} from './datetimeFormats';

export const getDateMMDDyyyy = (utcDate: string) => moment.utc(utcDate).format(dateMMddYYYYFormat);
